module.exports = __webpack_public_path__ + "static/media/STJOHNS_LOGO.5603d7e3.png";